import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IInputRuleBehavior } from "../../../../documaker/domain/format/objects";

export interface IInputRuleBehaviorPropertyEditable {
  inputRuleBehavior(): IPropertyEditable<IInputRuleBehavior>;
}

export function instanceOfIInputRuleBehaviorPropertyEditable(instance: any): instance is IInputRuleBehaviorPropertyEditable {
  return instance
      && instance.inputRuleBehavior
      && instanceOfIPropertyEditable<IInputRuleBehavior>(instance.inputRuleBehavior());
}
